import React, { useEffect, useState, useRef, useCallback } from "react";
import {
  Row,
  Col,
  CardBody,
  Card,
  Alert,
  Container,
  Input,
  Label,
  Form,
  FormFeedback,
  InputGroup,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

import {  toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// action
import { registerTrialUser, apiError, resetRegisterFlag } from "../../slices/thunks";
import { getTrialDays } from "../../apiCalls/caller";

//redux
import { useSelector, useDispatch } from "react-redux";

import { Link, useNavigate } from "react-router-dom";

import bcrypt from "bcryptjs-react";

//import images
import logoLight from "../../assets/images/buyers-club.png";
import { createSelector } from "reselect";

const flagImages = require.context("../../assets/images/flags", false, /\.svg$/);
const getFlag = (iso) => {
  try {
    return flagImages(`./${iso.toLowerCase()}.svg`);
  } catch {
    return null;
  }
};

const COUNTRY_CODES = [
  { dial: "+1", iso: "US" },{ dial: "+7", iso: "RU" },{ dial: "+20", iso: "EG" },
  { dial: "+27", iso: "ZA" },{ dial: "+30", iso: "GR" },{ dial: "+31", iso: "NL" },
  { dial: "+32", iso: "BE" },{ dial: "+33", iso: "FR" },{ dial: "+34", iso: "ES" },
  { dial: "+36", iso: "HU" },{ dial: "+39", iso: "IT" },{ dial: "+40", iso: "RO" },
  { dial: "+41", iso: "CH" },{ dial: "+43", iso: "AT" },{ dial: "+44", iso: "GB" },
  { dial: "+45", iso: "DK" },{ dial: "+46", iso: "SE" },{ dial: "+47", iso: "NO" },
  { dial: "+48", iso: "PL" },{ dial: "+49", iso: "DE" },{ dial: "+51", iso: "PE" },
  { dial: "+52", iso: "MX" },{ dial: "+53", iso: "CU" },{ dial: "+54", iso: "AR" },
  { dial: "+55", iso: "BR" },{ dial: "+56", iso: "CL" },{ dial: "+57", iso: "CO" },
  { dial: "+58", iso: "VE" },{ dial: "+60", iso: "MY" },{ dial: "+61", iso: "AU" },
  { dial: "+62", iso: "ID" },{ dial: "+63", iso: "PH" },{ dial: "+64", iso: "NZ" },
  { dial: "+65", iso: "SG" },{ dial: "+66", iso: "TH" },{ dial: "+81", iso: "JP" },
  { dial: "+82", iso: "KR" },{ dial: "+84", iso: "VN" },{ dial: "+86", iso: "CN" },
  { dial: "+90", iso: "TR" },{ dial: "+91", iso: "IN" },{ dial: "+92", iso: "PK" },
  { dial: "+93", iso: "AF" },{ dial: "+94", iso: "LK" },{ dial: "+95", iso: "MM" },
  { dial: "+98", iso: "IR" },{ dial: "+211", iso: "SS" },{ dial: "+212", iso: "MA" },
  { dial: "+213", iso: "DZ" },{ dial: "+216", iso: "TN" },{ dial: "+218", iso: "LY" },
  { dial: "+220", iso: "GM" },{ dial: "+221", iso: "SN" },{ dial: "+222", iso: "MR" },
  { dial: "+223", iso: "ML" },{ dial: "+224", iso: "GN" },{ dial: "+225", iso: "CI" },
  { dial: "+226", iso: "BF" },{ dial: "+227", iso: "NE" },{ dial: "+228", iso: "TG" },
  { dial: "+229", iso: "BJ" },{ dial: "+230", iso: "MU" },{ dial: "+231", iso: "LR" },
  { dial: "+232", iso: "SL" },{ dial: "+233", iso: "GH" },{ dial: "+234", iso: "NG" },
  { dial: "+235", iso: "TD" },{ dial: "+236", iso: "CF" },{ dial: "+237", iso: "CM" },
  { dial: "+238", iso: "CV" },{ dial: "+239", iso: "ST" },{ dial: "+240", iso: "GQ" },
  { dial: "+241", iso: "GA" },{ dial: "+242", iso: "CG" },{ dial: "+243", iso: "CD" },
  { dial: "+244", iso: "AO" },{ dial: "+245", iso: "GW" },{ dial: "+246", iso: "IO" },
  { dial: "+247", iso: "SH" },{ dial: "+248", iso: "SC" },{ dial: "+249", iso: "SD" },
  { dial: "+250", iso: "RW" },{ dial: "+251", iso: "ET" },{ dial: "+252", iso: "SO" },
  { dial: "+253", iso: "DJ" },{ dial: "+254", iso: "KE" },{ dial: "+255", iso: "TZ" },
  { dial: "+256", iso: "UG" },{ dial: "+257", iso: "BI" },{ dial: "+258", iso: "MZ" },
  { dial: "+260", iso: "ZM" },{ dial: "+261", iso: "MG" },{ dial: "+262", iso: "RE" },
  { dial: "+263", iso: "ZW" },{ dial: "+264", iso: "NA" },{ dial: "+265", iso: "MW" },
  { dial: "+266", iso: "LS" },{ dial: "+267", iso: "BW" },{ dial: "+268", iso: "SZ" },
  { dial: "+269", iso: "KM" },{ dial: "+290", iso: "SH" },{ dial: "+291", iso: "ER" },
  { dial: "+297", iso: "AW" },{ dial: "+298", iso: "FO" },{ dial: "+299", iso: "GL" },
  { dial: "+350", iso: "GI" },{ dial: "+351", iso: "PT" },{ dial: "+352", iso: "LU" },
  { dial: "+353", iso: "IE" },{ dial: "+354", iso: "IS" },{ dial: "+355", iso: "AL" },
  { dial: "+356", iso: "MT" },{ dial: "+357", iso: "CY" },{ dial: "+358", iso: "FI" },
  { dial: "+359", iso: "BG" },{ dial: "+370", iso: "LT" },{ dial: "+371", iso: "LV" },
  { dial: "+372", iso: "EE" },{ dial: "+373", iso: "MD" },{ dial: "+374", iso: "AM" },
  { dial: "+375", iso: "BY" },{ dial: "+376", iso: "AD" },{ dial: "+377", iso: "MC" },
  { dial: "+378", iso: "SM" },{ dial: "+380", iso: "UA" },{ dial: "+381", iso: "RS" },
  { dial: "+382", iso: "ME" },{ dial: "+383", iso: "XK" },{ dial: "+385", iso: "HR" },
  { dial: "+386", iso: "SI" },{ dial: "+387", iso: "BA" },{ dial: "+389", iso: "MK" },
  { dial: "+420", iso: "CZ" },{ dial: "+421", iso: "SK" },{ dial: "+423", iso: "LI" },
  { dial: "+500", iso: "FK" },{ dial: "+501", iso: "BZ" },{ dial: "+502", iso: "GT" },
  { dial: "+503", iso: "SV" },{ dial: "+504", iso: "HN" },{ dial: "+505", iso: "NI" },
  { dial: "+506", iso: "CR" },{ dial: "+507", iso: "PA" },{ dial: "+508", iso: "PM" },
  { dial: "+509", iso: "HT" },{ dial: "+590", iso: "GP" },{ dial: "+591", iso: "BO" },
  { dial: "+592", iso: "GY" },{ dial: "+593", iso: "EC" },{ dial: "+594", iso: "GF" },
  { dial: "+595", iso: "PY" },{ dial: "+596", iso: "MQ" },{ dial: "+597", iso: "SR" },
  { dial: "+598", iso: "UY" },{ dial: "+599", iso: "CW" },{ dial: "+670", iso: "TL" },
  { dial: "+672", iso: "NF" },{ dial: "+673", iso: "BN" },{ dial: "+674", iso: "NR" },
  { dial: "+675", iso: "PG" },{ dial: "+676", iso: "TO" },{ dial: "+677", iso: "SB" },
  { dial: "+678", iso: "VU" },{ dial: "+679", iso: "FJ" },{ dial: "+680", iso: "PW" },
  { dial: "+681", iso: "WF" },{ dial: "+682", iso: "CK" },{ dial: "+683", iso: "NU" },
  { dial: "+685", iso: "WS" },{ dial: "+686", iso: "KI" },{ dial: "+687", iso: "NC" },
  { dial: "+688", iso: "TV" },{ dial: "+689", iso: "PF" },{ dial: "+690", iso: "TK" },
  { dial: "+691", iso: "FM" },{ dial: "+692", iso: "MH" },{ dial: "+850", iso: "KP" },
  { dial: "+852", iso: "HK" },{ dial: "+853", iso: "MO" },{ dial: "+855", iso: "KH" },
  { dial: "+856", iso: "LA" },{ dial: "+880", iso: "BD" },{ dial: "+886", iso: "TW" },
  { dial: "+960", iso: "MV" },{ dial: "+961", iso: "LB" },{ dial: "+962", iso: "JO" },
  { dial: "+963", iso: "SY" },{ dial: "+964", iso: "IQ" },{ dial: "+965", iso: "KW" },
  { dial: "+966", iso: "SA" },{ dial: "+967", iso: "YE" },{ dial: "+968", iso: "OM" },
  { dial: "+970", iso: "PS" },{ dial: "+971", iso: "AE" },{ dial: "+972", iso: "IL" },
  { dial: "+973", iso: "BH" },{ dial: "+974", iso: "QA" },{ dial: "+975", iso: "BT" },
  { dial: "+976", iso: "MN" },{ dial: "+977", iso: "NP" },{ dial: "+992", iso: "TJ" },
  { dial: "+993", iso: "TM" },{ dial: "+994", iso: "AZ" },{ dial: "+995", iso: "GE" },
  { dial: "+996", iso: "KG" },{ dial: "+998", iso: "UZ" },
];

const formatPhoneNumber = (value) => {
  // Only allow digits, spaces, dashes, parens
  return value.replace(/[^\d\s\-()]/g, "");
};

const FreeRegister = () => {
  const history = useNavigate();
  const dispatch = useDispatch();
  const [trialDays, setTrialDays] = useState(null);
  const [termsOpen, setTermsOpen] = useState(false);
  const [phoneDropdownOpen, setPhoneDropdownOpen] = useState(false);
  const phoneDropdownRef = useRef(null);

  const handleClickOutside = useCallback((e) => {
    if (phoneDropdownRef.current && !phoneDropdownRef.current.contains(e.target)) {
      setPhoneDropdownOpen(false);
    }
  }, []);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [handleClickOutside]);

  useEffect(() => {
    getTrialDays()
      .then((res) => {
        if (res?.success) setTrialDays(res.data);
      })
      .catch(() => {});
  }, []);

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      email: "",
      phoneCode: "+1",
      phone: "",
      smsAccepted: false,
      name: "",
      password: "",
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Please Enter Your Email"),
      phone: Yup.string()
        .required("Please enter your phone number")
        .test(
          "valid-phone",
          "Please enter a valid phone number, e.g. 555 123 4567",
          (value) => {
            if (!value) return true;
            const digits = value.replace(/\D/g, "");
            return digits.length >= 7 && digits.length <= 15;
          }
        ),
      smsAccepted: Yup.boolean()
        .oneOf([true], "You must accept to receive SMS notifications")
        .required("You must accept to receive SMS notifications"),
      name: Yup.string().required("Please Enter Your Full Name"),
      password: Yup.string().required("Please enter your password"),
    }),
    onSubmit: (values) => {
      var data = {
        email: values.email,
        phone: values.phone ? `${values.phoneCode} ${values.phone}` : "",
        name: values.name,
        password: bcrypt.hashSync(values.password, 10),
      };
      dispatch(registerTrialUser(data, history));
    },
  });

  const selectLayoutState = (state) => state.Account;
  const registerdatatype = createSelector(selectLayoutState, (account) => ({
    success: account.success,
    error: account.error,
  }));
  // Inside your component
  const { error, success } = useSelector(registerdatatype);

  useEffect(() => {
    dispatch(apiError(""));
  }, [dispatch]);

  useEffect(() => {
    if (success) {
      // Navigation is handled by registerTrialUser thunk
      setTimeout(() => {
        dispatch(resetRegisterFlag());
      }, 3000);
    }
  }, [dispatch, success, error, history]);

  document.title = `SignUp | ${process.env.REACT_APP_SITE_TITLE}`;

  return (
    <React.Fragment>
      <div className="auth-page-content">
        <Container>
          <Row>
            <Col lg={12}>
              <div className="text-center mt-sm-5 mb-4 text-white-50">
                <div>
                  <Link to="/" className="d-inline-block auth-logo">
                    <img
                      src={logoLight}
                      alt=""
                      style={{ width: "100%", maxWidth: "385px", height: "auto", marginTop:"1.5em" }}
                    />
                  </Link>
                </div>
              </div>
            </Col>
          </Row>

          <Row className="justify-content-center">
            <Col md={10} lg={10} xl={9}>
              <Card className="mt-4">
                <CardBody className="p-4">
                  <Row>
                    {/* Left Column - Membership Details */}
                    <Col lg={5} className="">
                      <div className="p-3">
                        <div className="text-center mb-4">
                          <h4 className="text-primary mb-2"><b>Free {trialDays ?? "..."} Day Trial</b></h4>
                          <h4 className="text-primary">Buyers Club Membership</h4>
                        </div>
                        
                        <div className="mb-3">
                          <h6 className="mb-3">Membership Includes:</h6>
                          <ul className="list-unstyled">
                            <li className="mb-2">
                              <i className="ri-check-line text-success me-2"></i>
                              Access to thousands of curated products that are updated daily
                            </li>
                            <li className="mb-2">
                              <i className="ri-check-line text-success me-2"></i>
                              No need to set up supplier accounts, we do the heavy lifting!
                            </li>
                            <li className="mb-2">
                              <i className="ri-check-line text-success me-2"></i>
                              Integration with Sellercloud ($1200 value) which allows for inventory management and fulfillment across 100's of sales channels.
                            </li>
                            <li className="mb-2">
                              <i className="ri-check-line text-success me-2"></i>
                              Automated process from product ordering to end customer fulfillment
                            </li>
                            <li className="mb-2">
                              <i className="ri-check-line text-success me-2"></i>
                              Weekly HOT list items that are fast selling!
                            </li>
                          </ul>
                        </div>
                        
                        <div className="alert alert-info border-0 mb-0" role="alert">
                          <p className="mb-0 fs-12">
                            <strong>*</strong> Free Trial has access to view our catalog and features!
                          </p>
                        </div>
                      </div>
                    </Col>

                    {/* Right Column - Registration Form */}
                    <Col lg={7}>
                      <div className="p-3">
                        <div className="text-center mb-4">
                          <h5 className="text-primary">Create New Account</h5>
                          <p className="text-muted">
                            Get your {process.env.REACT_APP_SITE_TITLE} account now
                          </p>
                        </div>
                    <Form
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                      className="needs-validation"
                      action="#"
                    >
                      {success && success ? (
                        <>
                          {toast("Register User Successfully.", {
                            position: "top-right",
                            hideProgressBar: false,
                            className: "bg-success text-white",
                            progress: undefined,
                            toastId: "",
                          })}                      
                          <Alert color="success">
                            Register User Successfully. Check your email for
                            verification link.
                          </Alert>
                        </>
                      ) : null}

                      {error && error ? (
                        <Alert color="danger" fade={false}>
                          <div>
                            Email has been Register Before, Please Use Another
                            Email Address...{" "}
                          </div>
                        </Alert>
                      ) : null}

                      <div className="mb-3">
                        <Label htmlFor="email" className="form-label">
                          Email <span className="text-danger">*</span>
                        </Label>
                        <Input
                          id="email"
                          name="email"
                          className="form-control"
                          placeholder="Enter email address"
                          type="email"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.email || ""}
                          invalid={
                            validation.touched.email && validation.errors.email
                              ? true
                              : false
                          }
                        />
                        {validation.touched.email && validation.errors.email ? (
                          <FormFeedback type="invalid">
                            <div>{validation.errors.email}</div>
                          </FormFeedback>
                        ) : null}
                      </div>

                      <div className="mb-3">
                        <Label htmlFor="phone" className="form-label">
                          Phone <span className="text-danger">*</span>
                        </Label>
                        <InputGroup>
                          <div ref={phoneDropdownRef} style={{ position: "relative", maxWidth: 130 }}>
                            <button
                              type="button"
                              className="btn btn-light border d-flex align-items-center gap-1 w-100"
                              style={{ height: "100%", borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
                              onClick={() => setPhoneDropdownOpen((o) => !o)}
                            >
                              {(() => {
                                const sel = COUNTRY_CODES.find((c) => c.dial === validation.values.phoneCode);
                                const flag = sel ? getFlag(sel.iso) : null;
                                return flag ? <img src={flag} alt="" style={{ width: 20, height: 14 }} /> : null;
                              })()}
                              <span>{validation.values.phoneCode}</span>
                              <i className="ri-arrow-down-s-line ms-auto"></i>
                            </button>
                            {phoneDropdownOpen && (
                              <ul
                                className="list-unstyled bg-white border rounded shadow-sm mb-0"
                                style={{
                                  position: "absolute",
                                  top: "100%",
                                  left: 0,
                                  zIndex: 1050,
                                  maxHeight: 220,
                                  overflowY: "auto",
                                  width: 170,
                                  padding: "4px 0",
                                }}
                              >
                                {COUNTRY_CODES.map((c) => {
                                  const flag = getFlag(c.iso);
                                  return (
                                    <li
                                      key={c.dial}
                                      className="d-flex align-items-center gap-2 px-3 py-1"
                                      style={{ cursor: "pointer" }}
                                      onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#f0f0f0")}
                                      onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "transparent")}
                                      onClick={() => {
                                        validation.setFieldValue("phoneCode", c.dial);
                                        setPhoneDropdownOpen(false);
                                      }}
                                    >
                                      {flag && <img src={flag} alt={c.iso} style={{ width: 20, height: 14 }} />}
                                      <span>{c.dial}</span>
                                    </li>
                                  );
                                })}
                              </ul>
                            )}
                          </div>
                          <Input
                            id="phone"
                            name="phone"
                            placeholder="555 123 4567"
                            type="text"
                            onChange={(e) => {
                              const formatted = formatPhoneNumber(e.target.value);
                              validation.setFieldValue("phone", formatted);
                            }}
                            onBlur={validation.handleBlur}
                            value={validation.values.phone || ""}
                            invalid={
                              validation.touched.phone && validation.errors.phone
                                ? true
                                : false
                            }
                          />
                          {validation.touched.phone && validation.errors.phone ? (
                            <FormFeedback type="invalid">
                              <div>{validation.errors.phone}</div>
                            </FormFeedback>
                          ) : null}
                        </InputGroup>
                      </div>

                      <div className="mb-3">
                        <div className="form-check">
                          <Input
                            className="form-check-input"
                            type="checkbox"
                            id="smsAccepted"
                            name="smsAccepted"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            checked={validation.values.smsAccepted || false}
                            invalid={
                              validation.touched.smsAccepted &&
                              validation.errors.smsAccepted
                                ? true
                                : false
                            }
                          />
                          <Label className="form-check-label fs-12" htmlFor="smsAccepted">
                            I agree to receive SMS notifications and updates from{" "}
                            {process.env.REACT_APP_SITE_TITLE}
                            <span className="text-danger"> *</span>
                          </Label>
                          {validation.touched.smsAccepted &&
                          validation.errors.smsAccepted ? (
                            <FormFeedback type="invalid" className="d-block">
                              {validation.errors.smsAccepted}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </div>

                      <div className="mb-3">
                        <Label htmlFor="name" className="form-label">
                          Full Name <span className="text-danger">*</span>
                        </Label>
                        <Input
                          id="name"
                          name="name"
                          type="text"
                          placeholder="Enter full name"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.name || ""}
                          invalid={
                            validation.touched.name && validation.errors.name
                              ? true
                              : false
                          }
                        />
                        {validation.touched.name && validation.errors.name ? (
                          <FormFeedback type="invalid">
                            <div>{validation.errors.name}</div>
                          </FormFeedback>
                        ) : null}
                      </div>

                      <div className="mb-3">
                        <Label htmlFor="password" className="form-label">
                          Password <span className="text-danger">*</span>
                        </Label>
                        <Input
                          id="password"
                          name="password"
                          type="password"
                          placeholder="Enter Password"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.password || ""}
                          invalid={
                            validation.touched.password &&
                            validation.errors.password
                              ? true
                              : false
                          }
                        />
                        {validation.touched.password &&
                        validation.errors.password ? (
                          <FormFeedback type="invalid">
                            <div>{validation.errors.password}</div>
                          </FormFeedback>
                        ) : null}
                      </div>

                      <div className="mb-3">
                        <p className="mb-0 fs-12 text-muted fst-italic">
                          By registering you agree to the{" "}
                          {process.env.REACT_APP_SITE_TITLE}{" "}
                          <a
                            href="#terms"
                            className="text-primary text-decoration-underline fst-normal fw-medium"
                            onClick={(e) => {
                              e.preventDefault();
                              setTermsOpen(true);
                            }}
                          >
                            Terms of Use
                          </a>
                        </p>
                      </div>

                      <Modal isOpen={termsOpen} toggle={() => setTermsOpen(false)} size="xl" centered scrollable>
                        <ModalHeader toggle={() => setTermsOpen(false)}>Terms and Conditions</ModalHeader>
                        <ModalBody style={{ padding: 0, height: "70vh", overflow: "hidden" }}>
                          <iframe
                            src="https://mybuyersclub.net/terms-and-conditions.html"
                            title="Terms and Conditions"
                            style={{
                              width: "100%",
                              height: "calc(100% + 160px)",
                              border: "none",
                              marginTop: -160,
                            }}
                          />
                        </ModalBody>
                      </Modal>

                      <div className="mt-4">
                        <button className="btn btn-success w-100" type="submit">
                          Sign Up
                        </button>
                      </div>
                    </Form>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default FreeRegister;